export enum CartType {
  ShoppingCart = 'SHOPPING_CART',
  WishList = 'WISH_LIST',
}

export enum CartStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
}

export enum TripType {
  MULTICITY = 'MC',
  ROUNDTRIP = 'RT',
  ONEWAY = 'OW',
}

export enum BundleType {
  Blue = 'BLUE',
  BlueBasic = 'BLUE_BASIC',
  BluePlus = 'BLUE_PLUS',
  BlueExtra = 'BLUE_EXTRA',
  Mint = 'MINT',
}

export enum FlyingAirline {
  JetBlue = 'JetBlue',
  SilverAirways = 'Silver Airways',
  HawaiianAirlines = 'Hawaiian Airlines',
}

export enum AirlineCode {
  B6 = 'B6',
  A32S = '32S',
  A3NS = '3NS',
}

export enum Aircraft {
  A320 = 'A320',
  A220 = 'A220',
  A321 = 'A321',
  A321Mint = 'A321/Mint',
  E190 = 'E190',
}

export enum SegmentClass {
  Departing = 'departing',
  Returning = 'returning',
}

export enum BookingClass {
  C = 'C',
  E = 'E',
  J = 'J',
  L = 'L',
  P = 'P',
  S = 'S',
  Y = 'Y',
  K = 'K',
  H = 'H',
  Q = 'Q',
  V = 'V',
  B = 'B',
  R = 'R',
  W = 'W',
  M = 'M',
  Z = 'Z',
  O = 'O',
  U = 'U',
}

export enum CabinClass {
  C = 'C',
  NA = 'N/A',
  Y = 'Y',
}
